export const NEW_PROJECT_ID_PLACEHOLDER = "NEW_PROJECT_ID_PLACEHOLDER";
